import {IReg, REG} from "/@lib@/commons/registry.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";
import {BaseElement, MsgLabel, OMsgLabelInit, OSkinableInit} from "/@back@/commons/basis.js";
import {IWspUiEnv} from "/@lib@/wsp/wsp.js";
import {JSrcFields, SRC} from "/@lib@/wsp/src.js";
import {STYLER} from "/@lib@/styler/styler.js";
import {StylerSkinCLass} from "/@back@/styler/widgets/widgets.js";

/**
 * Preview d'un skinCLass
 * 		class : details
 */
export class SkinClassStlPreview extends BaseElement {
	private reg: IReg<IWspUiEnv>;

	private shortDesc: JSrcFields;

	private mode?: 'details' | 'preview'

	private contentElt: HTMLDivElement;

	_initialize(init: OSkinableInit & { shortDesc: JSrcFields, mode?: 'details' | 'preview' }) {
		this.reg = this.findReg(init);
		this.shortDesc = init.shortDesc;
		this.mode = init.mode || 'preview';

		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);
		this.contentElt = sr.appendChild(<div class="props"/>) as HTMLDivElement;
	}

	protected async _refresh() {
		this.contentElt.textContent = "";
		const msgElt = this.contentElt.appendChild(<MsgLabel class="headband" î={{level: "info", label: "Chargement en cours..."} as OMsgLabelInit}/>) as MsgLabel;

		if (this.shortDesc) {
			let longDesc = await this.reg.env.wsp.fetchLongDesc(SRC.srcRef(this.shortDesc), this);
			const skinClassStlCode = (longDesc as any).itAttr_skClassStl;
			const skinClassStl = STYLER.getSkinClassStl(this.reg.env.wsp, skinClassStlCode);
			//const wspTypesDefList = await WSPPACK.listWspTypesDef(this.reg.env.universe.packServer, [skinClassStl.class], true);

			if (skinClassStl) {
				const skinClass = skinClassStl.skinClass(this.reg.env.wsp);
				this.contentElt.textContent = "";

				// - title
				//if(this.mode=='preview')  this.contentElt.appendChild(<div class="maintitle">{skinClassStl.name}</div>);

				// - skinClass
				if (this.mode == 'preview') this.contentElt.appendChild(<div class="subtitle"><StylerSkinCLass î={{skinCLass: skinClassStl.class, reg: this.reg}}/></div>);

				const mainUlPropsElt = this.contentElt.appendChild(<ul/>);

				// - Props "Modèle d'appartenance de ce skin styler"
				if (this.mode == 'details') {
					const model = skinClassStl.ownerWspTypeStlName;
					const modelTxt = `Extension de stylage d'appartenance : ${model}`;
					if (model) mainUlPropsElt.appendChild(<li>{modelTxt}</li>);
				}

			} else
				msgElt.setCustomMsg("Aucune information disponible", 'info');
		} else
			msgElt.setCustomMsg("Aucune information disponible", 'info');
	}
}

REG.reg.registerSkin('styler-skin-preview', 1, /* language=CSS */ `
	:host {
		font-size: .8em;
		color: var(--info-color);
	}
	
	.maintitle {
		color: var(--alt2-color);
		font-variant: small-caps;
		font-weight: bold;
	}

	.subtitle {
		color: var(--alt2-color);
		font-weight: bold;
		text-align: end;
	}

	.version {
		font-style: italic;
	}

	.version::before {
		content: "(";
	}

	.version::after {
		content: ") :";
	}

	.info {
		font-style: italic;
	}

	.props > ul > li {
		margin-block-start: .5rem;
	}

	ul {
		margin-block-start: 0;
		padding-inline-start: 0em;
		list-style-type: none;
	}

	ul > * > ul {
		padding-inline-start: 1.5rem;
		list-style-type: "- ";
	}

`);

customElements.define('styler-skin-preview', SkinClassStlPreview);
